import "../../global.css"

export default function SidebarLayout({ children, title }) {
  return (
    <div className="flex flex-col gap-6">
      {title ? (
        <header className="flex flex-col gap-2">
          <h1 className="text-3xl font-bold text-foreground">{title}</h1>
        </header>
      ) : null}
      <div className="flex flex-col gap-4">{children}</div>
    </div>
  );
}
